module.exports = __webpack_public_path__ + "static/jack-ward-rknrvCrfS1k-unsplash-60f3c6e6c7d046e71e276211d36a6086.png";